import { useRef } from "react";
import { Form, useSubmit, Link } from "react-router";

import { useAllJobsContext } from "@/pages/all-jobs";
import { JOB_SORT_TYPE, JOB_STATUS, JOB_TYPE } from "@/helpers";

import { DashboardFormPageWrapper } from "@/components/wrappers";

import { FormRow, FormRowSelect } from ".";

const SearchContainer = () => {
  const { searchValues } = useAllJobsContext();
  const { search, jobStatus, jobType, sort } = searchValues;
  const submit = useSubmit();
  const timeoutId = useRef(0);

  const handleSearchJobs = (e: React.FormEvent<HTMLInputElement>) => {
    clearTimeout(timeoutId.current);
    const form = e.currentTarget.form;

    timeoutId.current = setTimeout(() => {
      submit(form);
    }, 800) as unknown as number;
  };

  const jobStatuses = Object.values(JOB_STATUS);
  const jobTypes = Object.values(JOB_TYPE);
  const jobSortTypes = Object.values(JOB_SORT_TYPE);

  return (
    <DashboardFormPageWrapper>
      <Form>
        <h5 className="form-title">search form</h5>
        <div className="form-center">
          <FormRow type="search" name="search" defaultValue={search} onChange={handleSearchJobs} />
          <FormRowSelect labelText="job status" name="jobStatus" list={["all", ...jobStatuses]} defaultValue={jobStatus} onChange={e => submit(e.currentTarget.form)} />
          <FormRowSelect labelText="job type" name="jobType" list={["all", ...jobTypes]} defaultValue={jobType} onChange={e => submit(e.currentTarget.form)} />
          <FormRowSelect name="sort" list={jobSortTypes} defaultValue={sort} onChange={e => submit(e.currentTarget.form)} />
          <Link className="btn form-btn delete-btn" to="/dashboard/all-jobs">
            Reset Search Values
          </Link>
        </div>
      </Form>
    </DashboardFormPageWrapper>
  );
};

export default SearchContainer;
